<script setup>
import PostSaleAddressFilter from './PostSaleAddressFilter.vue';

defineProps({
  addressFilters: { type: Object, required: true },
  addressOptions: { type: Array, default: () => [] },
  addressesLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['searchAddresses', 'setAddress']);
</script>

<template>
  <section class="w-full lg:w-1/2">
    <PostSaleAddressFilter
      :filters="addressFilters"
      :loading="addressesLoading"
      :options="addressOptions"
      @apply="emit('setAddress', $event)"
      @search="emit('searchAddresses', $event)"
    />
  </section>
</template>
